import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksResourceCountsConstructor,
  QuickBooksResourceCounts,
} from './QuickBooksResourceCounts'

export const QuickBooksResourceCountsConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksResourceCountsConstructor>({
    importable: Factory.each(() => faker.random.number(99)),
    imported: Factory.each(() => faker.random.number(99)),
    exportable: null,
    exported: null,
    archived: null,
  })

export const QuickBooksResourceCountsFactory = EntityFactory(
  QuickBooksResourceCounts,
  QuickBooksResourceCountsConstructorFactory
)
